import {ModuleComponent} from "../../js/module-component";

export class ModAccordion extends ModuleComponent{
    ready(){
        super.ready();

        const items = document.querySelectorAll(".accordion button");
        items[0].setAttribute("aria-expanded","true");
        function toggleAccordion(){
            const itemToggle = this.getAttribute("aria-expanded");
            let i = 0;
            for(i = 0; i<items.length; i++){
                items[i].setAttribute("aria-expanded","false");
            }
            if(itemToggle=="false"){
                this.setAttribute("aria-expanded","true");
            }
        }

        items.forEach(item=>item.addEventListener("click",toggleAccordion));
    }

}
